define(["jquery", "core/ajax", "core/notification", "core/templates", "core/modal_factory", "core/modal_events", "sweetalert2", "select2-js", "datatables.net", "datatables.net", "datatables.net-bs4", "datatables.net-buttons", "datatables.net-buttons-bs4", "datatables.net-buttons-colvis", "datatables.net-buttons-print", "datatables.net-buttons-html", "datatables.net-buttons-flash", "datatables.net-responsive", "datatables.net-responsive-bs4"], 
function(a, b, c, d, e, f, Swal) {
    return {
        init: function() {

            var collegeval = '';
            var industryval = '';

            a("#College").select2({
                placeholder: {
                    id: '0',
                    text: 'Choose College'
                }
            }), a("#Industry").select2({
                placeholder: {
                    id: '0',
                    text: 'Choose Industry'
                }
            });

            var d = b.call([{
                methodname: "local_student_stream_table",
                args: {
                    nullid: 1,
                    college: collegeval,
                    industry: industryval,
                }
            }]);
            d[0].done(function(b) {
                b.length;
                var tablehead = '';
                tablehead += '<table class="table" id="stream_table">';
                tablehead += '<thead id="stream_table_head">';
                tablehead += '<tr>';
                tablehead += '<th class="text-center">Sl.No.</th>';
                tablehead += '<th>Programme</th>';
                tablehead += '<th>Stream Id</th>';
                tablehead += '<th>Stream Full Name</th>';
                tablehead += '<th>Created By</th>';
                tablehead += '<center><th class="text-center custom_width_datatable">Actions</th></center>';
                tablehead += '</tr>';
                tablehead += '</thead>';
                tablehead += '<tbody>';
                tablehead += '</tbody>';
                tablehead += '</table>';
                a(".table").empty(),
                a(".table").append(tablehead),
                $i = 1;
                if (b.length !== 0) {
                    for (var c = 0; c < b.length; c++) {
                        var tabledata = '';
                        tabledata += '<tr>';
                        tabledata += '<td class="text-center text-muted">' + $i + '</td>';
                        tabledata += '<td>' + b[c].programme + '</td>';
                        tabledata += '<td>' + b[c].shortname + '</td>';
                        tabledata += '<td>' + b[c].fullname + '</td>';
                        tabledata += '<td>' + b[c].createdby + '</td>';
                        tabledata += '<td style="text-align: center;">' + b[c].action + '</td>';
                        tabledata += '</tr>';
                        a("tbody").append(tabledata), $i++;
                    }
                } else {
                    var emptytab = '';
                    emptytab += '<tr data-no-results-found>';
                    emptytab += '<td></td><td></td><td></td>';
                    emptytab += '<td style="text-align:left">NO RECORDS FOUND</td>';
                    emptytab += '<td></td><td></td>';
                    emptytab += '</tr>';
                    a("tbody").append(emptytab);
                }
                a("#stream_table").DataTable()
            }).fail(function(a) {

            }), 
            a(document).on("click", ".stream_add", function(d) {
                if (a("#stream_id").val() && "" == a("#editshortname").val()) d.preventDefault(), a(".error_shortname").show();
                else if (a("#stream_id").val() && "" == a("#editfullname").val()) d.preventDefault(), a(".error_fullname").show();
                else if (a("#stream_id").val() && "" == a("#editprogramme").val()) d.preventDefault(), a(".error_programme").show();
                else if (a("#programme").val() || a("#stream_id").val())
                    if ("" != a("#shortname").val() || a("#stream_id").val())
                        if ("" != a("#fullname").val() || a("#stream_id").val()) {
                            d.preventDefault();
                            var e = b.call([{
                                methodname: "local_student_add_stream",
                                args: {
                                    programme: a("#programme").val() ? a("#programme").val() : a("#editprogramme").val(),
                                    shortname: a("#shortname").val() ? a("#shortname").val() : a("#editshortname").val(),
                                    fullname: a("#fullname").val() ? a("#fullname").val() : a("#editfullname").val(),
                                    stream_id: a("#stream_id").val() ? a("#stream_id").val() : ""
                                }
                            }]);
                            e[0].done(function(b) {
                                a("#stream_modal").modal("hide"), "already" == b ? Swal.fire({
                                    icon: "error",
                                    title: "Stream id already exists",
                                    timer: 1500
                                }) : Swal.fire({
                                    position: "center",
                                    icon: "success",
                                    title: a("#stream_id").val() ? "Updated Successfully" : "Added Successfully",
                                    showConfirmButton: !1,
                                    timer: 1500
                                }), setTimeout(function() {
                                    location.reload(true);
                                }, 1500)
                            }).fail(function(a) {
                                c.addNotification({
                                    type: "error",
                                    message: a.message.replace("Exception - ", "")
                                })
                            })
                        } else d.preventDefault(), a(document).scrollTop(0), c.addNotification({
                            type: "error",
                            message: "Enter Stream FullName"
                        }), setTimeout(function() {
                            a(".notifications").empty()
                        }, 3e3);
                        else d.preventDefault(), a(document).scrollTop(0), c.addNotification({
                            type: "error",
                            message: "Enter Stream ShortName"
                        }), setTimeout(function() {
                            a(".notifications").empty()
                        }, 3e3);
                        else d.preventDefault(), a(document).scrollTop(0), c.addNotification({
                            type: "error",
                            message: "Select Programme to add Stream"
                        }), setTimeout(function() {
                            a(".notifications").empty()
                        }, 3e3)
                    });


            a(document).on("click", ".stream_edit", function(d) {
                if (a("#stream_id").val() && "" == a("#editfullname").val()) d.preventDefault(), a(".error_fullname").show();
                else if (a("#stream_id").val() && "" == a("#editprogramme").val()) d.preventDefault(), a(".error_programme").show();
                else if (a("#programme").val() || a("#stream_id").val())
                    if (a("#stream_id").val())
                        if ("" != a("#fullname").val() || a("#stream_id").val()) {
                            d.preventDefault();
                            var e = b.call([{
                                methodname: "local_student_edit_stream",
                                args: {
                                    programme: a("#programme").val() ? a("#programme").val() : a("#editprogramme").val(),
                                    // shortname: a("#shortname").val() ? a("#shortname").val() : a("#editshortname").val(),
                                    fullname: a("#fullname").val() ? a("#fullname").val() : a("#editfullname").val(),
                                    stream_id: a("#stream_id").val() ? a("#stream_id").val() : ""
                                }
                            }]);
                            e[0].done(function(b) {
                                a("#stream_modal").modal("hide"), "already" == b ? Swal.fire({
                                    icon: "error",
                                    title: "Stream id already exists",
                                    timer: 1500
                                }) : Swal.fire({
                                    position: "center",
                                    icon: "success",
                                    title: a("#stream_id").val() ? "Updated Successfully" : "Added Successfully",
                                    showConfirmButton: !1,
                                    timer: 1500
                                }), setTimeout(function() {
                                    location.reload(true);
                                }, 1500)
                            }).fail(function(a) {
                                c.addNotification({
                                    type: "error",
                                    message: a.message.replace("Exception - ", "")
                                })
                            })
                        } else d.preventDefault(), a(document).scrollTop(0), c.addNotification({
                            type: "error",
                            message: "Enter Stream FullName"
                        }), setTimeout(function() {
                            a(".notifications").empty()
                        }, 3e3);
                        setTimeout(function() {
                            a(".notifications").empty()
                        }, 3e3);
                    });

                    // Choose College.
                    a('#College').change(function () {
                        a('#Industry').select2("val", "0");
                        a("#istream_table").remove();
                        var college = a('#College').val();
                        var cprogramme = 0;
                        var cstream = 1;
                        var csemester = 0;
                        var csemesteryear = 0;
                        var promises = b.call([
                        {
                            methodname: 'local_student_college_programme_details',
                            args: {
                                college : college,
                                cprogramme : cprogramme,
                                cstream : cstream,
                                csemester : csemester,
                                csemesteryear : csemesteryear
                            }
                        }
                        ]);
                        promises[0].done(function(b) {
                            b.length;
                            var tablehead = '';
                            tablehead += '<table class="table" id="cstream_table">';
                            tablehead += '<thead id="cstream_table_head">';
                            tablehead += '<tr>';
                            tablehead += '<th class="text-center">Sl.No.</th>';
                            tablehead += '<th>Programme</th>';
                            tablehead += '<th>Stream Id</th>';
                            tablehead += '<th>Stream Full Name</th>';
                            tablehead += '<center><th class="text-center custom_width_datatable">Actions</th></center>';
                            tablehead += '</tr>';
                            tablehead += '</thead>';
                            tablehead += '<tbody>';
                            tablehead += '</tbody>';
                            tablehead += '</table>';
                            a(".table").empty(),
                            a(".table").append(tablehead),
                            $i = 1;
                            if (b.length !== 0) {
                                for (var c = 0; c < b.length; c++) {
                                    var tabledata = '';
                                    tabledata += '<tr>';
                                    tabledata += '<td class="text-center text-muted">' + $i + '</td>';
                                    tabledata += '<td>' + b[c].programme + '</td>';
                                    tabledata += '<td>' + b[c].shortname + '</td>';
                                    tabledata += '<td>' + b[c].fullname + '</td>';
                                    tabledata += '<td style="text-align: center;">' + b[c].action + '</td>';
                                    tabledata += '</tr>';
                                    a("tbody").append(tabledata), $i++;
                                }
                            } else {
                                var emptytab = '';
                                emptytab += '<tr data-no-results-found>';
                                emptytab += '<td></td><td></td>';
                                emptytab += '<td style="text-align:center">NO RECORDS FOUND</td>';
                                emptytab += '<td></td><td></td>';
                                emptytab += '</tr>';
                                a("tbody").append(emptytab);
                            }
                            a("#cstream_table").DataTable();
                        }).fail(function(a) {

                        });
                    });

                    // Choose Industry.
                    a('#Industry').change(function () {
                    // Set selected.
                    // a('#College').select2("val", "0");
                    a("#cstream_table").remove();
                    var industry = a('#Industry').val();
                    var iprogramme = 0;
                    var istream = 1;
                    var isemester = 0;
                    var isemesteryear = 0;
                    var promises = b.call([
                    {
                        methodname: 'local_student_industry_programme_details',
                        args: {
                            industry : industry,
                            iprogramme : iprogramme,
                            istream : istream,
                            isemester : isemester,
                            isemesteryear : isemesteryear
                        }
                    }
                    ]);
                    promises[0].done(function(b) {
                        b.length;
                        var tablehead = '';
                        tablehead += '<table class="table" id="istream_table">';
                        tablehead += '<thead id="istream_table_head">';
                        tablehead += '<tr>';
                        tablehead += '<th class="text-center">Sl.No.</th>';
                        tablehead += '<th>Programme</th>';
                        tablehead += '<th>Stream Id</th>';
                        tablehead += '<th>Stream Full Name</th>';
                        tablehead += '<center><th class="text-center custom_width_datatable">Actions</th></center>';
                        tablehead += '</tr>';
                        tablehead += '</thead>';
                        tablehead += '<tbody>';
                        tablehead += '</tbody>';
                        tablehead += '</table>';
                        a(".table").empty(),
                        a(".table").append(tablehead),
                        $i = 1;
                        if (b.length !== 0) {
                            for (var c = 0; c < b.length; c++) {
                                var tabledata = '';
                                tabledata += '<tr>';
                                tabledata += '<td class="text-center text-muted">' + $i + '</td>';
                                tabledata += '<td>' + b[c].programme + '</td>';
                                tabledata += '<td>' + b[c].shortname + '</td>';
                                tabledata += '<td>' + b[c].fullname + '</td>';
                                tabledata += '<td style="text-align: center;">' + b[c].action + '</td>';
                                tabledata += '</tr>';
                                a("tbody").append(tabledata), $i++;
                            }
                        } else {
                            var emptytab = '';
                            emptytab += '<tr data-no-results-found>';
                            emptytab += '<td></td><td></td>';
                            emptytab += '<td>NO RECORDS FOUND</td>';
                            emptytab += '<td></td><td></td>';
                            emptytab += '</tr>';
                            a("tbody").append(emptytab);
                        }
                        a("#istream_table").DataTable();
                    }).fail(function(a) {

                    });
                });


                a("#cc_custom").on("click", function(s) {

                        var coddevalue = a("#shortname").val();
                        var z = document.getElementById("cc_custom");

                        if(1 == z.checked) {
                            document.getElementById("shortname").disabled = !1;

                        } else { 

                         var code =  a("#shortname").val();
                         document.getElementById("shortname").disabled = !0;

                         var i = b.call([{
                            methodname: "local_course_get_stream_code",
                            args: {
                                id: code
                            }
                        }]);
                         i[0].done(function(result) {

                            a("#shortname").val(result);

                        }).fail(function(result) {
                            d.preventDefault(), a(document).scrollTop(0), c.addNotification({
                                type: "error",
                                message: "ERROR"
                            })
                        });

                    }

                })



                    a(document).on("click", ".delete_stream", function(d) {
                        d.preventDefault();
                        var g = a(d.currentTarget);
                        e.create({
                            type: e.types.SAVE_CANCEL,
                            title: "Delete Stream Details",
                            body: "Do you really want to delete?"
                        }).then(function(a) {
                            a.setSaveButtonText("Delete");
                            var d = a.getRoot();
                            d.on(f.save, function() {
                                var a = g.data("id"),
                                d = b.call([{
                                    methodname: "local_student_stream_delete",
                                    args: {
                                        stream_id: a
                                    }
                                }]);
                                d[0].done(function(a) {
                                    Swal.fire({
                                        position: "center",
                                        icon: "success",
                                        title: "Deleted Successfully",
                                        showConfirmButton: !1,
                                        timer: 1500
                                    }), setTimeout(function() {
                                        location.reload(true);
                                    }, 1500)
                                }).fail(function(a) {
                                    c.addNotification({
                                        type: "error",
                                        message: a.message.replace("Exception - ", "")
                                    })
                                })
                            }), a.show()
                        })
                    }), 
                    a(document).on("click", ".edit_stream", function(b) {
                        a(".error_fullname").hide(), a(".error_shortname").hide(), a("#stream_id").val(a(this).data("id")), a("#editprogramme").val(a(this).data("programme")).trigger("change"), a("#editfullname").val(a(this).data("fullname")), a("#editshortname").val(a(this).data("shortname"))
                    }), a("#programme_modal").on("hidden.bs.modal", function(b) {
                        a("#programme_id").val("")
                    }), a("#editshortname").keyup(function() {
                        a(".error_shortname").hide()
                    }), a("#editfullname").keyup(function() {
                        a(".error_fullname").hide()
                    }), a("#stream_modal").on("hidden.bs.modal", function(b) {
                        a("#stream_id").val("")
                    })
                }
            }
        });